var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVsd = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 36,
  x: 9,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M9 29h30v7a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M30 29V2h7a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#00754A",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m6.46 17.61 1.96 5.5 1.99-5.5h1.29l-2.71 7.14H7.83l-2.72-7.14zm6.809 4.96q.08.7.5 1.02.43.32 1.27.32.41 0 .69-.09t.45-.24a.8.8 0 0 0 .24-.35q.07-.21.07-.44 0-.17-.05-.33a.8.8 0 0 0-.18-.31 1.1 1.1 0 0 0-.35-.24 2 2 0 0 0-.56-.17l-.91-.17a6 6 0 0 1-.96-.25q-.42-.15-.71-.39a1.7 1.7 0 0 1-.43-.6 2.4 2.4 0 0 1-.14-.87q0-.51.2-.89.21-.38.57-.63.36-.26.85-.38a4.3 4.3 0 0 1 1.08-.13q.74 0 1.24.17t.81.45q.31.27.47.63t.22.75l-1.14.18q-.14-.6-.49-.89-.34-.29-1.09-.29-.43 0-.72.08-.28.07-.46.21a.8.8 0 0 0-.25.31.9.9 0 0 0-.07.36q0 .47.25.7.26.23.9.36l.99.19q1.13.21 1.66.72.53.5.53 1.45 0 .45-.17.84a1.8 1.8 0 0 1-.5.67 2.5 2.5 0 0 1-.85.44 3.6 3.6 0 0 1-1.17.17q-1.37 0-2.15-.57-.78-.58-.86-1.79zm8.025 1.15q.63 0 1.07-.18.45-.18.73-.52.291-.34.42-.81.13-.47.13-1.06 0-1.18-.5-1.84-.5-.67-1.64-.67h-1.38v5.08zm.2-6.11q.79 0 1.42.22.63.21 1.07.65t.67 1.11q.24.66.24 1.55t-.25 1.57a3.05 3.05 0 0 1-.72 1.13q-.47.45-1.15.68-.67.23-1.52.23h-2.34v-7.14z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVsd);
export default ForwardRef;